import { withStyles } from '../../tools/withStyles';
import { Component } from './App';
import { styles } from './App.styles';

const App = withStyles(styles)(Component);

export { App };
